module.exports = __webpack_public_path__ + "img/3-1.ee6b41e9.jpg";